import _ from "lodash";
import React, { useEffect } from "react";
import classnames from "classnames";

import { Icon } from "@sportal/cdk";
import { useOutsideClick, useToggle } from "@sportal/cdk/hooks";

import "./MobileMenu.scss";

export const MobileMenu = ({ children, toggleState, toggleFn }) => {
  const [opened, setOpened] = useToggle(false);
  const toggle = toggleFn || setOpened;

  const menuRef = useOutsideClick(() => toggle(false), opened);

  const menuClasses = classnames("mobile-side-menu", {
    "mobile-side-menu--opened": opened,
  });

  useEffect(() => {
    if (!_.isUndefined(toggleState)) {
      setOpened(toggleState);
    }
  }, [toggleState, setOpened]);

  return (
    <div className={menuClasses}>
      <div onClick={toggle} className="mobile-side-menu__toggle">
        <Icon icon="fa-solid fa-cog" />
      </div>
      <div className="mobile-side-menu__menu" ref={menuRef}>
        {children}
      </div>
    </div>
  );
};
